<template>
  <div>
    <!-- Master -->
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-body">
<div class="mb-3">
  <div class="row">
    <div class="col-1"><label class="form-label">Número</label></div>
    <div class="col-2">
      <p class="form-control-plaintext">{{ datoFactura.numero }}</p>
    </div>
    <div class="col-2"><label class="form-label">Fecha Emisión</label></div>
    <div class="col-2">
      <p class="form-control-plaintext">{{ getFormattedDate(datoFactura.fechaEmision) }}</p>
    </div>
    <div class="col-1"><label class="form-label">Estado</label></div>
    <div class="col-2">
      <p class="form-control-plaintext">{{ datoFactura.estadoFactura === 'P' ? 'Pendiente' : 'Emitida' }}</p>
    </div>
  </div>
</div>
<div class="mb-3">
  <div class="row">
    <div class="col-1"><label class="form-label">Persona</label></div>
    <div class="col-11">
      <p class="form-control-plaintext">{{ nombrePersona }}</p>
    </div>
  </div>
</div>
<div class="mb-3">
  <div class="row">
    <div class="col-1"><label class="form-label">Descripción</label></div>
    <div class="col-11">
      <p class="form-control-plaintext">{{ datoFactura.descripcion }}</p>
    </div>
  </div>
</div>

        </div>
      </div>
    </div>

    <!-- Detalle -->
    <hr>
    <table class="table table-bordered table-sm">
      <thead class="table-dark">
        <tr>
          <th>Descripción</th>
          <th class="text-end">Cantidad</th>
          <th class="text-end">Precio Unitario</th>
          <th class="text-end">Subtotal</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="det in datosPaginados" :key="det.idFacturaDet">
          <td>{{ det.descripcion }}</td>
          <td class="text-end">{{ det.cantidad }}</td>
          <td class="text-end">{{ det.precioUnitario }}</td>
          <td class="text-end">{{ det.subtotal }}</td>
        </tr>
      </tbody>
      <tfoot>
        <tr class="table-secondary fw-bold">
          <td colspan="2" class="text-end">Sub-Total:</td>
          <td class="text-end">{{ totalPrecioTotal }}</td>
          <td class="text-end">{{ totalSubTotal }}</td>
        </tr>
      </tfoot>
    </table>

    <!-- Impuestos -->
    <div class="d-flex justify-content-end">
      <div style="flex: 0 1 50%;">
        <table class="table table-bordered table-sm">
          <thead class="table-dark">
            <tr>
              <th>Impuesto</th>
              <th class="text-end">Base Imponible</th>
              <th class="text-end">Monto Impuesto</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="imp in facturaimps" :key="imp.idFacturaImp">
              <td>{{ imp.impuestoNombre }}</td>
              <td class="text-end">{{ imp.baseImponible }}</td>
              <td class="text-end">{{ imp.montoImpuesto }}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr class="table-secondary fw-bold">
              <td colspan="2" class="text-end">Sub-Total Impuestos:</td>
              <td class="text-end">{{ totalImpuestos }}</td>
            </tr>
            <tr class="table-secondary fw-bold">
              <td colspan="2" class="text-end">TOTAL:</td>
              <td class="text-end">{{ totalSubTotal + totalImpuestos }}</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import dateFormat from '@/modules/dateFormat.js'
import api        from '@/services/api'

export default {
  name: 'FacturaVer',

  props: { p_idFactura: { type: [String, Number], required: true } },

  data() {
    return {
      datoFactura:        {},
      facturadets:        [],
      facturaimps:        [],
      datosPaginados:     [],
      personas:           [],
      paginaActual:       1,
      elementosPorPagina: 10,
      mostrarBloque:      false,
    }
  },

  watch: {
    p_idFactura: {
      immediate: true,
      handler(val) {
        if (val) {
          this.cargarFactura()
          this.getDataPaginaTodos(1)
          this.getImpuestos()
          this.fetchPersonas()
        }
      },
    },
  },

  computed: {
    nombrePersona() {
      const p = this.personas.find(p => p.idPersona === this.datoFactura.idPersona)
      return p ? p.nombreCompleto : ''
    },
    totalPrecioTotal() {
      return this.datosPaginados.reduce((acc, d) => acc + d.cantidad * d.precioUnitario, 0)
    },
    totalSubTotal() {
      return this.datosPaginados.reduce((acc, d) => acc + d.subtotal, 0)
    },
    totalImpuestos() {
      return this.facturaimps.reduce((acc, i) => acc + i.montoImpuesto, 0)
    },
  },

  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date)
    },

    cargarFactura() {
      api.get(`/vwfacturas/${this.p_idFactura}`)
        .then(resp => { this.datoFactura = resp.data })
    },

    getDataPaginaTodos(noPagina) {
      api.get(`/vwfacturadets/idfactura/${this.p_idFactura}`).then(response => {
        this.facturadets  = response.data.reverse()
        this.paginaActual = noPagina
        const ini         = (noPagina - 1) * this.elementosPorPagina
        this.datosPaginados = this.facturadets.slice(ini, ini + this.elementosPorPagina)
      })
    },

    getImpuestos() {
      api.get(`/vwfacturaimps/idfactura/${this.p_idFactura}`)
        .then(resp => { this.facturaimps = resp.data })
    },

    totalPaginas() {
      return Math.ceil(this.facturadets.length / this.elementosPorPagina)
    },

    getPreviousPage() {
      if (this.paginaActual > 1) this.paginaActual--
      this.getDataPaginaTodos(this.paginaActual)
    },

    getNextPage() {
      if (this.paginaActual < this.totalPaginas()) this.paginaActual++
      this.getDataPaginaTodos(this.paginaActual)
    },

    isActive(noPagina) {
      return noPagina === this.paginaActual ? 'active' : ''
    },

    fetchPersonas() {
      api.get('/vwpersonas')
        .then(resp => { this.personas = resp.data })
        .catch(err => console.error('Error fetching personas:', err))
    },
  },
}
</script>